
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ai-terms",
      function () {
        return require("private-next-pages/ai-terms/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ai-terms"])
      });
    }
  